import Vue from 'vue'
import Vuex from 'vuex'
import {list, listFilters, getRDIGraphs} from '@/helpers/api/rdi'
import {getProjectRequest, isCurrentProjectRequest} from '@/helpers/projectContext'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		listadoRDI: {
			status: 99,
			count: 0,
			total_rdi: 0,
			data: []
		},
		listadoRDITotal: 0,
		createRDIModal: false,
		weeklyDashboardModal: false,
		draftToLoad: null,
		listingOrder: 1,
		selectedType: 2,
		currentRDI: null,
		initialDataRDI: null,
		borradorRDI: null,
		rdiGraphsDataCountBySpecialty: {
			status: 99,
			data: null
		},
		loadingChangeVisualizationStatus: [],
		specialtyFilter: [],
		subjectFilter: [],
		responsableFilter: [],
		rdiFilterSpecialties: [],
		rdiFilterSubjects: [],
		loadingRdiFilters: false,
		loadingRdiFiltersRequestKey: null,
		loadedRdiFiltersKey: null,
	},
	mutations: {
		setListadoRDI(state, rdis){
			state.listadoRDI = rdis
			state.listadoRDITotal = rdis.total_rdi
		},
		setCurrentRDI(state, rdi){
			state.currentRDI = rdi
		},
		setBorradorRDI(state, rdi){
			state.borradorRDI = rdi
		},
		setSelectedType(state, type){
			state.selectedType = type
		},
		setListingOrder(state){
			let currentStatus = state.listingOrder
			if(currentStatus === 4){
				currentStatus = 1
			}
			else{
				currentStatus++
			}
			state.listingOrder = currentStatus
		},
		setCreateRDIModal(state, status){
			state.createRDIModal = status
			if(!status) {
				state.draftToLoad = null
			}
		},
		setDraftToLoad(state, draft){
			state.draftToLoad = draft
		},
		setWeeklyDashboardModal(state, status){
			state.weeklyDashboardModal = status
		},
		setInitialDataRDI(state, data){
			state.initialDataRDI = data
		},
		setSpecialtyFilter(state, data){
			state.specialtyFilter = data
		},
		setSubjectFilter(state, data){
			state.subjectFilter = data
		},
		setResponsableFilter(state, data){
			state.responsableFilter = data
		},
		setRdiFilterSpecialties(state, data){
			state.rdiFilterSpecialties = data
		},
		setRdiFilterSubjects(state, data){
			state.rdiFilterSubjects = data
		},
		setLoadingRdiFilters(state, status){
			state.loadingRdiFilters = status
		},
		setLoadingRdiFiltersRequestKey(state, value){
			state.loadingRdiFiltersRequestKey = value
		},
		setLoadedRdiFiltersKey(state, value){
			state.loadedRdiFiltersKey = value
		},
		setRdiGraphsDataCountBySpecialty(state, data){
			state.rdiGraphsDataCountBySpecialty = data
		},
		addLoadingChangeVisualizationStatus(state, newItemID){
			const changingStatus = [...state.loadingChangeVisualizationStatus]
			const found = changingStatus.find((item) => item === newItemID)
			if(!found){
				changingStatus.push(newItemID)
			}
			state.loadingChangeVisualizationStatus = changingStatus
		},
		removeLoadingChangeVisualizationStatus(state, itemID){
			const changingStatus = [...state.loadingChangeVisualizationStatus]
			const foundIndex = changingStatus.findIndex((item) => item === itemID)
			if(foundIndex !== -1){
				changingStatus.splice(foundIndex, 1)
			}
			state.loadingChangeVisualizationStatus = changingStatus
		}
		},
		resetForProject(state){
			state.listadoRDI = {status: 99, count: 0, total_rdi: 0, data: []}
			state.listadoRDITotal = 0
			state.rdiGraphsDataCountBySpecialty = {status: 99, data: null}
			state.specialtyFilter = []
			state.subjectFilter = []
			state.responsableFilter = []
			state.rdiFilterSpecialties = []
			state.rdiFilterSubjects = []
			state.loadingRdiFilters = false
			state.loadingRdiFiltersRequestKey = null
			state.loadedRdiFiltersKey = null
			state.currentRDI = null
			state.initialDataRDI = null
			state.borradorRDI = null
			state.draftToLoad = null
			state.createRDIModal = false
			state.weeklyDashboardModal = false
			state.loadingChangeVisualizationStatus = []
	},
	actions: {
		async getRDIFilters(context, query){
			const request = getProjectRequest(query.project_id)
			let status = 1
			if(context.state.selectedType === 3){
				status = 3
			}
			const requestKey = `${query.project_id}-${status}`
			if(context.state.loadedRdiFiltersKey === requestKey){
				return
			}
			if(context.state.loadingRdiFilters && context.state.loadingRdiFiltersRequestKey === requestKey){
				return
			}
			context.commit('setLoadingRdiFilters', true)
			context.commit('setLoadingRdiFiltersRequestKey', requestKey)

			try{
				const filters = await listFilters({
					project_id: query.project_id,
					status
				})
				if(isCurrentProjectRequest(request.projectId, request.generation) && filters.code === 200){
					context.commit('setRdiFilterSpecialties', filters.specialties || [])
					context.commit('setRdiFilterSubjects', filters.subjects || [])
				}
				if(isCurrentProjectRequest(request.projectId, request.generation)) context.commit('setLoadedRdiFiltersKey', requestKey)
			} finally {
				if(isCurrentProjectRequest(request.projectId, request.generation)){
					context.commit('setLoadingRdiFilters', false)
					context.commit('setLoadingRdiFiltersRequestKey', null)
				}
			}
		},
		async getRdiGraphsData(context, query){
			const request = getProjectRequest(query.project_id)
			const data = {
				project_id: query.project_id
			}
			let graphsData = Object.assign(context.state.rdiGraphsDataCountBySpecialty, {status: 99})
			context.commit('setRdiGraphsDataCountBySpecialty', graphsData)
			const graphs = await getRDIGraphs(data)
			if(isCurrentProjectRequest(request.projectId, request.generation) && graphs.code === 200){
				context.commit('setRdiGraphsDataCountBySpecialty', {
					status: 1,
					data: {
						specialties: graphs.specialties,
						time_average: graphs.time_average,
						rdis_count: graphs.rdis_count,
						rdis_pending: graphs.rdis_pending,
						rdis_ended: graphs.rdis_ended,
					}
				})
			}
		},
		async getRDI(context, query){
			const request = getProjectRequest(query.project_id)
			let status = 1
			let page = 1
			let per_page = 50
			if(context.state.selectedType === 3){
				status = 3
			}
			if(query.page){
				page = query.page
			}

			const data = {
				project_id: query.project_id,
				status,
				order: context.state.listingOrder,
				start: per_page * (page - 1),
				limit: per_page,
				filtered_specialties: context.state.specialtyFilter,
				filtered_subjects: context.state.subjectFilter,
				filtered_responsable: context.state.responsableFilter,
			}

			context.dispatch('getRDIFilters', {project_id: query.project_id})

			let listing = {status: 99, count: 0, total_rdi: 0, data: []}
			context.commit('setListadoRDI', listing)
			const rdis = await list(data)
			if(isCurrentProjectRequest(request.projectId, request.generation) && rdis.code === 200){
				context.commit('setListadoRDI', {
					status: 1,
					count: rdis.rdi.length,
					data: rdis.rdi,
					total_rdi: rdis.total_rdi,
				})
			}
		},
		updateRdiLocally(context, newRdiData){
			const rdiIndex = context.state.listadoRDI.data.findIndex((rdi) => { return rdi.id === newRdiData.id })
			if(rdiIndex !== -1){
				const rdis = [...context.state.listadoRDI.data]
				rdis[rdiIndex] = newRdiData
				context.commit('setListadoRDI', {
					status: 1,
					count: context.state.listadoRDI.count,
					data: rdis,
					total_rdi: context.state.listadoRDI.total_rdi,
				})
			}
		}
	},
	getters: {
		currentTarea: state => {
			return state.currentTarea
		}
	}
})

export default store
